var _a;
import { getNumberOfDaysSinceSignup } from '../auth';
import { Referrer } from '../utils.constant';
export class AnalyticsUtils {
    static getIsEligibleForRudderstackAnalytics() {
        return this.commonProperties.isEligibleForRudderstackAnalytics;
    }
    static setCommonProperties(properties) {
        AnalyticsUtils.commonProperties = properties;
    }
    static getReferrer() {
        return AnalyticsUtils.referrer;
    }
    static setReferrer(referrer) {
        AnalyticsUtils.referrer = referrer;
    }
    static setDeviceId(deviceId) {
        AnalyticsUtils.deviceId = deviceId;
    }
    static getDeviceId() {
        return AnalyticsUtils.deviceId;
    }
    static setDeviceInfo(deviceInfo) {
        AnalyticsUtils.deviceInfo = deviceInfo;
    }
    static getDeviceInfo() {
        return AnalyticsUtils.deviceInfo;
    }
    static registerPage(pageType, data) {
        AnalyticsUtils.pageType = pageType;
        AnalyticsUtils.data = data;
    }
    static getPage() {
        return AnalyticsUtils.pageType;
    }
    static getPageData() {
        return AnalyticsUtils.data;
    }
    static getSanitizedUser() {
        const user = this.userData;
        if (!user) {
            return {};
        }
        const daysSinceSignup = getNumberOfDaysSinceSignup(this.userData);
        return {
            email: user.email,
            first_name: user.first_name,
            last_name: user.last_name,
            role: user.role,
            id: user.id,
            'Plan Duration': user?.plan_duration,
            'User Plan': user?.payment_plan,
            'Account Id': user?.account,
            bucket: user?.bucket,
            'sub bucket': user?.sub_bucket,
            export_video_count: user?.export_video_count,
            export_project_count: user?.export_project_count,
            daysSinceSignup: daysSinceSignup,
            weeksSinceSignup: Math.floor(daysSinceSignup / 7),
        };
    }
    static getSanitizedUserV2() {
        const user = this.userData;
        if (!user) {
            return {};
        }
        return {
            email: (user.email ?? '').toLowerCase(),
            first_name: (user.first_name ?? '').toLowerCase(),
            last_name: (user.last_name ?? '').toLowerCase(),
            role: (user.role ?? '').toLowerCase(),
            user_id: user.id,
            plan_duration: (user?.plan_duration ?? '').toLowerCase(),
            user_plan: (user?.payment_plan ?? '').toLowerCase(),
            account_id: user?.account,
            bucket: (user?.bucket ?? '').toLowerCase(),
            sub_bucket: (user?.sub_bucket ?? '').toLowerCase(),
        };
    }
    static toSnakeCase(value = 'na') {
        return value.toLowerCase().replaceAll(' ', '_');
    }
    static transformPropertiesToSnakeCase(properties) {
        if (Object.keys(properties).length === 0) {
            return {};
        }
        const transformedProperties = {};
        for (let [key, value] of Object.entries(properties)) {
            const newKey = AnalyticsUtils.toSnakeCase(key);
            const newValue = typeof value === 'string' ? AnalyticsUtils.toSnakeCase(value) : value;
            transformedProperties[newKey] = newValue;
        }
        return transformedProperties;
    }
    static getUserId() {
        const sanitizedUser = AnalyticsUtils.getSanitizedUser();
        return sanitizedUser?.id;
    }
    get userData() {
        return this.userData;
    }
    set userData(user) {
        this.userData = user;
    }
    static setAnonymousId(id) {
        this.anonymousId = id;
    }
    static getAnonymousId() {
        return this.anonymousId;
    }
    static getChannel() {
        return this.channel;
    }
    static setChannel(ch) {
        this.channel = ch;
    }
}
_a = AnalyticsUtils;
AnalyticsUtils.referrer = Referrer.WEBSITE;
AnalyticsUtils.channel = 'na';
AnalyticsUtils.deviceId = '';
AnalyticsUtils.anonymousId = '';
AnalyticsUtils.pageType = '';
AnalyticsUtils.commonProperties = {
    isClassic: false,
    isUploadExperiment: false,
    app_source: '',
    browser: {
        name: '',
        version: '',
    },
    os: {
        name: '',
        version: '',
    },
    device_info: {
        cpu: -1,
        ram: -1,
    },
    isEligibleForRudderstackAnalytics: false,
};
AnalyticsUtils.commonRudderStackEventProperties = () => {
    let eventProperties = {
        eligibility: {
            classic: _a.commonProperties.isClassic,
            absolute_iv_frame: true,
            ram: true,
            webgl2: true,
        },
        variants: {
            editor: _a.commonProperties.isClassic ? 'classic' : 'frame',
            upload_post_processing: true,
            webgl: true,
            watermark_on_video: true,
            upload_enhancement_experiment: false,
            module_federation: true,
            max_video_limit_increase: true,
            nov_setting_v2: 'Fallback',
            audio: 'iv-audio',
            storyboard: 'v2',
            timeline: 'layered-timeline',
            renderer: 'frame',
            stitcher: 'frame',
        },
        app: {
            name: window.location.hostname,
            version: process.env.REACT_APP_VERSION,
            variant: 'react',
        },
        app_source: _a.commonProperties.app_source,
        platform: 'web',
        browser: {
            name: _a.commonProperties.browser.name,
            version: _a.commonProperties.browser.version,
        },
        screen_resolution: {
            width: window.screen.width,
            height: window.screen.height,
        },
        os: {
            name: _a.commonProperties.os.name,
            version: _a.commonProperties.os.version,
        },
        device_info: {
            cpu: _a.commonProperties.device_info.cpu,
            ram: _a.commonProperties.device_info.ram,
        },
    };
    if (_a.userData?.account_details) {
        eventProperties.variants['upload_enhancement'] =
            _a.commonProperties.isUploadExperiment;
    }
    if (_a.userData) {
        const daysSinceSignup = getNumberOfDaysSinceSignup(_a.userData);
        eventProperties['user_stats'] = {
            export_video_count: _a.userData?.export_video_count ?? 0,
            export_project_count: _a.userData?.export_project_count ?? 0,
            signup_since_days: daysSinceSignup,
        };
    }
    return eventProperties;
};
AnalyticsUtils.toAlphabeticSortedCSV = (map) => {
    const keys = Object.keys(map).sort();
    return keys
        .map(k => `${k}: ${map[k]}`)
        .join(', ')
        .toLowerCase();
};
AnalyticsUtils.getDeviceConfig = () => {
    return {
        ram: navigator.deviceMemory ?? -1,
        cpu: navigator.hardwareConcurrency ?? -1,
    };
};
AnalyticsUtils.toLowerCaseObject = (eventProperties) => {
    return Object.fromEntries(Object.entries(eventProperties)
        .map(([k, v]) => {
        return [k, typeof v === 'string' ? v.toLowerCase() : v];
    }));
};
AnalyticsUtils.toFeatureUtm = (featureUtm) => {
    const keys = Object.keys(featureUtm).sort();
    return keys
        .map(k => `${k}: ${featureUtm[k]}`)
        .join(', ')
        .toLowerCase();
};
